import React from 'react'
import RoleListTable from './Components/RoleListTable'

const RoleList = () => {
    return (
        <div className="container-fluid admin-module-page admin-rbac-page py-4">
            <div className="admin-page-header d-flex align-items-start justify-content-between flex-wrap gap-3 mb-4">
                <div>
                    <span className="admin-page-kicker">Access Control</span>
                    <h3 className="admin-page-title fw-bold mb-1">Role List</h3>
                    <p className="admin-page-description mb-0">
                        Manage roles with a create-and-edit flow.
                    </p>
                </div>
            </div>

            <div className="card admin-surface-card">
                <div className="card-body admin-surface-body">
                    <RoleListTable />
                </div>
            </div>
        </div>
    )
}

export default RoleList
